export default "__VITE_ASSET__CxHKjkWX__"